import React from "react";
import { Modal } from "react-bootstrap";
import CrossIcon from "assets/icons/crossAccent.svg";
import "./styles.scss";
import Button from "../Button";

interface Props {
  show: boolean;
  onClose?: () => void;
  title?: string;
  onOk?: () => void;
}

const ModalTitle = ({ show, onClose, title, onOk }: Props) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      animation={false}
      onExit={onClose}
      onBackdropClick={onClose}
      className="container-contact-modal">
      <div className="alert-global-wrapper">
        <div className="container-global-wrapper">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              cursor: "pointer"
            }}
            onClick={onClose}>
            <img src={CrossIcon} className="settings-img-modal" />
          </div>
          <div className="settings-title-modal-wrapper">
            <div className="settings-title-modal-container">
              <span className="settings-title-modal">{title}</span>
            </div>
            {!!onOk && (
              <Button typeBtn="red" text={"OK"} style={{ marginTop: 20 }} onClick={onOk} />
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalTitle;
